<template>
  <layout-main-inner title="新增订单">
    <el-form ref="ruleForm"
             :model="outstock"
             :rules="rules"
             label-position='top'>
      <layout-card-wrap hasHeaderSlot
                        v-loading="loading">
        <template slot="title">基本信息</template>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="订单号:"
                          prop="orderNumber">
              <el-input v-model="outstock.orderNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="收货信息:"
                          prop="deliveryAddressId">
              <!-- <delivery-select v-model="outstock.deliveryAddressId"
                               :callback="handleDeliveryChange"
                               :option="{vendorId: $route.query.vendorId}" /> -->
              <span v-if="outstock.deliveryAddressId"
                    style="margin-right: 10px;">{{ outstock.dealerName }}-{{ outstock.deliveryName }}-{{ outstock.address }}</span>
              <el-button type="text"
                         @click="selectCustomer">选择收货信息</el-button>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item label="收货地址:">
              <span v-if="outstock.provinceName">{{outstock.provinceName}}-{{outstock.cityName}}-{{outstock.areaName}}-{{outstock.detailedAddress}}</span>
            </el-form-item>
          </el-col> -->
        </el-row>
      </layout-card-wrap>
      <layout-card-wrap style="margin-top:15px"
                        hasHeaderSlot
                        v-loading="loading">
        <template slot="title">
          <span>订单明细</span>
          <el-button type="primary"
                     style="margin-left:10px"
                     @click="addProduct"
                     :loading="loading">选择商品</el-button>
        </template>
        <el-form-item label-width="0"
                      prop="productItems">
          <el-table :data="outstock.productItems"
                    border
                    v-loading="loading">
            <el-table-column label="商品名称"
                             min-width="200"
                             prop="productName"></el-table-column>
            <el-table-column label="备注"
                             min-width="180"
                             prop="productNameRemark">
            </el-table-column>
            <el-table-column label="商品类型"
                             min-width="80"
                             prop="categoryName"></el-table-column>
            <el-table-column label="赋码方式"
                             min-width="80">
              <template slot-scope="{row}">{{ row.codingType | codingType()}}</template>
            </el-table-column>
            <el-table-column label="订单数量"
                             prop="goodsCount"
                             min-width="120">
              <template slot-scope="{ row }">
                <!-- <el-form-item label-width='0'
                              :prop="'productItems.' + $index + '.goodsCount'"
                              :rules="[{required: true, message: '请输入订单数量', trigger: 'blur'}]"> -->
                <el-input-number v-if="row.codingType !== 2"
                                 v-model="row.goodsCount"
                                 :precision="0"
                                 :min="1"></el-input-number>
                <span v-else><span style="font-weight: bold;">{{ row.goodsCount }}</span> (根据批次信息生成)</span>
                <!-- </el-form-item> -->
              </template>
            </el-table-column>
            <el-table-column label="批次"
                             min-width="140">
              <template slot-scope="{row,$index}">
                <!-- <el-form-item label-width='0'
                              v-if="row.codingType === 2"
                              :prop="'productItems.' + $index + '.batchId'"
                              :rules="[{required: true, message: '请选择批次', trigger: 'blur'}]"> -->
                <!-- <product-batch-select v-model="outstock.productItems[$index].batchId"
                                        :option="{productId: row.productId, vendorId: row.vendorId}" /> -->
                <template v-if="row.codingType === 2">
                  <!-- <span style="margin-right: 10px;font-weight: bold;">已选{{ row.batchList.length }}个</span> -->
                  <el-button type="text"
                             @click="selectBatch(row,$index)">选择批次(已选{{ row.batchList.length }}个)</el-button>
                </template>
                <!-- </el-form-item> -->
                <!-- <template v-if="row.codingType === 2">
                  <span>{{ row.batchCode }}</span>
                  <span @click="selectBatch(row,$index)">选择批量</span>
                </template> -->
              </template>
            </el-table-column>
            <el-table-column label="操作"
                             width="60">
              <template slot-scope="{ $index }">
                <el-button type="text"
                           @click="deleteItem($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </layout-card-wrap>
    </el-form>
    <template slot="footer">
      <back-button ref="back" />
      <el-button type="primary"
                 @click="save"
                 :loading="loading">保存</el-button>
    </template>
    <product-select-modal @add="updateProductItems"
                          :option="{vendorId: $route.query.vendorId}"
                          ref="modal" />

    <package-select-modal ref="customer"
                          @select="onselect" />
    <product-batch-select-modal ref="batch"
                                @update="onSelectBatch"
                                @select="onSelectBatch" />
  </layout-main-inner>
</template>
<script>
// import DeliverySelect from './busi/delivery-select.vue'
import ProductSelectModal from './busi/product-select-modal-new.vue'
// import ProductBatchSelect from './busi/product-batch-select.vue'
import PackageSelectModal from '../delivery/select-customer-address/package-select-modal.vue'
import ProductBatchSelectModal from './busi/product-batch-select-modal.vue'
export default {
  name: 'outstock-create',
  components: { ProductSelectModal, PackageSelectModal, ProductBatchSelectModal },
  props: {},
  data () {
    return {
      loading: false,
      outstock: { orderNumber: '', deliveryAddressId: null, productItems: [] },
      rules: {
        deliveryAddressId: [
          { required: true, message: '请选择收货人', trigger: 'change' }
        ],
        productItems: [
          { type: 'array', required: true, message: '请选择商品', trigger: 'change' }
        ]
      },
      currentIndex: null
    }
  },
  watch: {},
  computed: {},
  methods: {
    deleteItem (index) {
      this.outstock.productItems.splice(index, 1)
    },
    selectBatch (row, $index) {
      this.currentIndex = $index
      const batchList = row.batchList || []
      this.$refs.batch.fetch({ productId: row.productId, vendorId: row.productId }, batchList)
    },
    onSelectBatch ({ batchList, goodsCount }) {
      // const { batchId, batchCode } = row
      const item = this.outstock.productItems[this.currentIndex]
      this.$set(this.outstock.productItems, this.currentIndex, { ...item, batchList, goodsCount })
    },
    selectCustomer () {
      this.$refs.customer.fetch()
    },
    onselect (row) {
      console.log(row)
      this.outstock = { ...this.outstock, ...row }
    },
    // handleDeliveryChange (val) {
    //   this.outstock = { ...this.outstock, ...val }
    // },
    addProduct () {
      this.$refs.modal.fetch(this.outstock.productItems.map(i => i.productId))
    },
    updateProductItems (list) {
      this.outstock.productItems.push(...list.map(i => ({ ...i, batchList: i.codingType === 2 ? [] : null })))
    },
    save () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let { orderNumber, deliveryAddressId, productItems } = this.outstock
          if (productItems.some(i => !i.goodsCount || i.goodsCount === 0)) {
            this.$message.error('商品的订单数量必须大于0')
            return
          }
          this.loading = true
          const vendorId = this.$route.query.vendorId
          const list = []
          productItems.forEach(i => {
            const { productId, goodsCount, batchList } = i
            if (batchList) {
              batchList.forEach(s => {
                list.push({ productId, goodsCount: s.goodsCount, batchId: s.batchId })
              })
            } else {
              list.push({ productId, goodsCount })
            }
          })
          this.$store.dispatch('outstock/addoutstockorder', {
            payload: { vendorId, orderNumber, deliveryAddressId, productItems: list },
            success: (res) => {
              this.loading = false
              this.$refs.back.back()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  },
  created () { },
  mounted () { }
}
</script>
<style lang="stylus"></style>
